// Catalogue mirror / presentation hints only. Database command owners resolve
// current effective grants and exact tenant/facility/region scope; this array
// cannot authorize a request or candidate/document download.
export const RECRUITMENT_CAPABILITIES = [
  'workforce.recruitment.view',
  'workforce.recruitment.manage',
  'workforce.recruitment.offer',
] as const;

export type RecruitmentCapability = (typeof RECRUITMENT_CAPABILITIES)[number];

export const RECRUITMENT_TENANT_WIDE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'OWNER',
  'CEO',
  'OPERATIONS_DIRECTOR',
  'HR_DIRECTOR',
] as const;

export const RECRUITMENT_SCOPED_ROLES = [
  'HR_OFFICER',
  'FACILITY_MANAGER',
  'REGION_MANAGER',
] as const;

export function hasRecruitmentBaselineRole(role: string | null | undefined): boolean {
  const normalized = role?.toUpperCase();
  return [...RECRUITMENT_TENANT_WIDE_ROLES, ...RECRUITMENT_SCOPED_ROLES].some(
    (allowed) => allowed === normalized,
  );
}
